<form>
  <div class="row">
    <div class="col-md-12 col-xl-12">
      <div class="table-responsive our-table">
        <table class="table table-striped text-nowrap mb-0">
          <thead class="border-top">
            <tr>
              <th scope="col" class="text-capitalize">
                {{ "common.accountId" | translate }}
              </th>
              <th scope="col" class="text-capitalize">
                {{ "common.client" | translate }}
              </th>
              <th scope="col" class="text-capitalize">
                {{ "common.fixedSplitDeposit" | translate }}
              </th>
              <th scope="col" class="text-capitalize">
                {{ "common.percentSplitDeposit" | translate }}
              </th>
              <th scope="col" class="text-capitalize">
                {{ "common.fixedSplitWithdraw" | translate }}
              </th>
              <th scope="col" class="text-capitalize">
                {{ "common.percentSplitWithdraw" | translate }}
              </th>
            </tr>
          </thead>

          <tbody>
            <tr class="border-bottom" *ngFor="let transaction of transactions">
              <td>
                <span>{{ transaction.accountId }}</span>
              </td>
              <td>
                <span>{{ transaction.description }}</span>
              </td>
              <td>
                <span>{{ transaction.depositTaxValue | formatCurrency }}</span>
              </td>
              <td>
                <span>
                  {{
                    (transaction.depositTaxPercent || 0) / 100
                      | percent : "1.2-2"
                  }}
                </span>
              </td>
              <td>
                <span>{{ transaction.withDrawTaxValue | formatCurrency }}</span>
              </td>
              <td>
                <span>
                  {{
                    (transaction.withDrawTaxPercent || 0) / 100
                      | percent : "1.2-2"
                  }}
                </span>
              </td>
            </tr>
            <tr *ngIf="transactions.length === 0">
              <td colspan="6">
                {{ "common.noData" | translate }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-between p-2">
        <ngb-pagination
          [collectionSize]="total"
          [maxSize]="5"
          [rotate]="true"
          [(page)]="page"
          [pageSize]="pageSize"
          (pageChange)="pageChange()"
        >
        </ngb-pagination>
      </div>
    </div>
  </div>
</form>
